import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const FloatIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M7 4C6.44772 4 6 4.44772 6 5V19C6 19.5523 6.44772 20 7 20H9.0964C9.64869 20 10.0964 20.4477 10.0964 21C10.0964 21.5523 9.64869 22 9.0964 22H7C5.34315 22 4 20.6569 4 19V5C4 3.34315 5.34315 2 7 2H13.5858C14.1162 2 14.6249 2.21071 15 2.58579L19.4142 7C19.7893 7.37507 20 7.88378 20 8.41421V11.0385C20 11.5908 19.5523 12.0385 19 12.0385C18.4477 12.0385 18 11.5908 18 11.0385V10H15C13.3431 10 12 8.65685 12 7V4H7ZM14 4.41421V7C14 7.55228 14.4477 8 15 8H17.5858L14 4.41421Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M20 17.6631C20 20.0565 18.0598 21.9966 15.6666 21.9966C13.2732 21.9966 11.3331 20.0565 11.3331 17.6631C11.3331 15.2698 13.2732 13.3297 15.6666 13.3297C18.0598 13.3297 20 15.2698 20 17.6631ZM16.3 15.65C16.3 15.291 16.009 15 15.65 15C15.291 15 15 15.291 15 15.65L15 18.0498C15 18.2233 15.0694 18.3895 15.1926 18.5116L16.195 19.5046C16.45 19.7572 16.8616 19.7553 17.1142 19.5002C17.3669 19.2452 17.3649 18.8337 17.1099 18.581L16.3 17.7788L16.3 15.65Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

FloatIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(FloatIcon);
